import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import type { ActivatedRouteSnapshot } from '@angular/router';
import { ActivationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AppTitleService {
    currentRoute: ActivatedRouteSnapshot;

    private baseTitle: string[] = [];

    private unreadCount = 0;

    constructor(
        private title: Title,
        private router: Router,
    ) {
        this.router.events
            .pipe(
                filter(event => event instanceof ActivationEnd),
                filter((event: ActivationEnd) => event.snapshot.data.title || event.snapshot.title),
                takeUntilDestroyed(),
            )
            .subscribe((event: ActivationEnd) => {
                if (event instanceof ActivationEnd) {
                    this.updateTitle(
                        event.snapshot.data.title ?? event.snapshot.title
                    );
                }
            });
    }

    updateTitle(...title: string[]) {
        this.baseTitle = title;
        this.applyTitle();
    }

    setUnreadCount(count: number): void {
        if (count === this.unreadCount) {
            return;
        }

        this.unreadCount = count;
        this.applyTitle();
    }

    private applyTitle(): void {
        const title = [...this.baseTitle, 'CareLineLive'].filter(Boolean).join(' | ');

        this.title.setTitle(this.unreadCount > 0 ? `(${this.unreadCount}) ${title}` : title);
    }
}
